export default __webpack_public_path__ + "static/media/example.5bb676d3.csv";